module.exports = __webpack_public_path__ + "media/components/src/assets/images/blogs/11-19cf146a4296a8647f4c066b564bced1.jpg";